module.exports = __webpack_public_path__ + "static/media/big-stitch-up-1.247d3c53.png";